/**
 * What every animation in the app asks before it moves.
 *
 * ONE ANSWER, shared by the camera tween (`features/map/mapController.ts`) and the node's
 * flight between surfaces (`app/flight.ts`), so the two cannot disagree about whether this
 * reader wants motion. It lives in `app/` rather than `lib/` because it reads `window` —
 * `lib/` is the DOM-free core and `lib/purity.test.ts` would refuse it there.
 *
 * `prefers-reduced-motion` ARRIVES, IT DOES NOT HURRY. Every caller skips to its destination
 * rather than shortening the trip: a faster animation is still an animation, which is not
 * what the setting asked for. That reading is also what keeps the regression suite honest —
 * `playwright.config.ts` runs it with `reducedMotion: 'reduce'`, so every existing spec sees the
 * destinations instantly and only `e2e/59-camera-motion.spec.ts`, which opts back in, sees
 * the travel.
 */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
